module.exports = __webpack_public_path__ + "img/step-1.e558d446.png";